import React from 'react';
import Checkbox from 'relements/build/esm/input/checkbox';
import Radio from 'relements/build/esm/input/radio';
import RangeSlider from 'relements/build/esm/input/rangeSlider';

const FEEDBACK_SETTINGS = {
  title: 'User Feedback',
  inputs: [
    {
      label: 'Collect User Feedback',
      key: 'collectFeedbackDelay',
      component: Checkbox.Item,
      props: (value, onChange) => ({
        onChange: val => onChange(val ? 120 : -1),
        value: value !== -1,
      }),
    },
    {
      label: 'FORCE_BREAK',
      key: 'forceBreak1',
      component: () => <div style={{ minWidth: '100%' }} />,
    },
    {
      label: '',
      key: 'collectFeedbackMultiple',
      component: Radio,
      className: 'full-width',
      props: (value, onChange, form) => ({
        invisible: form.collectFeedbackDelay === -1,
        value: { title: value ? 'Multiple Times' : 'One Time' },
        // we want to send a boolean value depending on if Multiple times is selected
        // newValue.title === 'Multiple Times' evaluates to true when it's selected
        onChange: newValue => onChange(newValue.title === 'Multiple Times'),
        options: [
          {
            title: 'One Time',
            hint:
              'This will collect feedback only once through a users lifetime.',
          },
          {
            title: 'Multiple Times',
            hint:
              'This will enable multiple feedback collection after every chat completion. Repetitive feedback won’t be collected if the feedback is collected in last 2 hrs.',
          },
        ],
      }),
    },
    {
      label: 'FORCE_BREAK',
      key: 'forceBreak2',
      component: () => <div style={{ minWidth: '100%' }} />,
    },
    {
      label: 'Delay ',
      key: 'collectFeedbackDelay',
      className: 'extra-long',
      component: RangeSlider,
      props: (value, onChange, form) => ({
        invisible: form.collectFeedbackDelay === -1,
        start: 0,
        end: 1200,
        step: 5,
        single: true,
        prefixClassName: 'feedback-delay',
        placeholder: 'Delay By (seconds)',
      }),
    },
  ],
};

export default FEEDBACK_SETTINGS;
